import {debug, find} from "../utility/functions";
import {decrypt, encrypt} from "../actions";

export const keys = {
    accessToken: {
        key: 'access_token',
    },
    expiresIn: {
        key: 'expires_in',
    },
    refreshToken: {
        key: 'refresh_token',
    },
    tokenType: {
        key: 'token_type'
    },
    loggedIn: {
        key: 'logged_in'
    },
    active: {
        key: 'active',
    },
    contact: {
        key: 'contact',
    },
    county: {
        key: 'county',
    },
    email: {
        key: 'email',
    },
    schoolId: {
        key: 'school_id',
    },
    info: {
        key: 'info',
    },
    island: {
        key: 'island',
    },
    name: {
        key: 'name',
        path: 'school.name'
    },
    role: {
        key: 'role',
    },
    personal_data: {
        key: 'personal_data',
    },
    author: {
        key: 'author',
        path: 'aoAccountInfo.name',
    },
    yearInfo: {
        key: 'year_info',
        path: 'yearInfo'
    }
};



export const getPathOrKey = (key) => {
    if(find(key, 'path')) return find(key, 'path');
    return find(key, 'key');
};

export function getItem(key) {
    //debug("Getting item '" + key.key + "' from LocalStorage and Decrypting its value");
    const k = localStorage.key(key.key);
    const value = localStorage.getItem(key.key);
    if (k !== null && k !== 'i18nextLng' && value !== null) {
        //debug("Item Decrypted -> " + decrypt(localStorage.getItem(key.key)));
        try {
            return JSON.parse(decrypt(localStorage.getItem(key.key)));
        }catch (e) {
            return null;
        }
    }
    //debug("Key is not stored in the Local Storage, returning Null");
    return null;
}

export function setItem(key, value) {
    if (value !== null && key !== undefined) {
        //debug("Storing in key: '"+key.key+"' the value of " + value);
        try {
            localStorage.setItem(key.key, encrypt(JSON.stringify(value)));
        } catch (e) {}
    }
}

export const setItems = (response) => {
    Object.keys(keys).forEach(key => {
        const keyObject = find(keys, key);
        const value = find(response, getPathOrKey(keyObject), 2);
        debug("value", value);
        if(value !== undefined) {
            if(key === "personal_data") {
                debug("HERE")
            }
            setItem(keyObject, value)
        }
    });
};
